<cwc-page class="app-shell-page">
  <cwc-header
    slot="header"
    variant="positive"
    show-menu-button="mobile"
    show-cemex-logo="false"
    [showMenuButton]="true"
    (cwcSidenavToggle)="onSidenavToggle()"
  >
    <div class="app-shell-logo" slot="logo">
      <img *ngIf="logo" [src]="logo" alt="Application logo" />
      <span *ngIf="!logo" class="app-shell-name">{{ appName }}</span>
    </div>

    <div class="app-shell-header-right">
      <span class="app-shell-user">{{ userName }}</span>
    </div>
  </cwc-header>

  <cwc-sidenav slot="sidenav" variant="positive" [open]="openMenu" (collapsed)="onMenuCollapsed($event)">
    <cwc-sidenav-menu slot="menu-items" variant="positive" [collapsed]="!openMenu">
      <cwc-sidenav-menu-item
        *ngFor="let item of menuItems"
        [label]="item.label"
        [iconName]="item.iconName"
        variant="positive"
        class="positive v2"
        (cwcClick)="navigate(item)"
      ></cwc-sidenav-menu-item>
    </cwc-sidenav-menu>
  </cwc-sidenav>

  <div slot="main" class="app-shell-main" ngClass="{ 'action-bar': actionBarPortal }">
    <section class="app-shell-content">
      <ng-content></ng-content>
    </section>

    <section
      *ngIf="actionBarPortal"
      class="app-shell-action-bar"
      [class.active]="forceActionBarLayout || !!actionBarPortal"
    >
      <ng-content select="[appShellActionBar]"></ng-content>
      <ng-template [cdkPortalOutlet]="actionBarPortal"></ng-template>
    </section>
  </div>
</cwc-page>
